/**
 * QRスキャナー用のWASM初期化
 *
 * このファイルはアプリケーション起動時に1度だけ実行され、
 * barcode-detectorがローカルのWASMファイルを使用するように設定します。
 *
 * @see https://github.com/Sec-ant/barcode-detector?tab=readme-ov-file#preparezxingmodule
 */

import { prepareZXingModule } from '@yudiel/react-qr-scanner';

let isInitialized = false;

/**
 * QRスキャナーのWASM設定を初期化する
 *
 * この関数は複数回呼ばれても安全で、最初の呼び出し時のみ初期化を実行します。
 */
export function initializeQRScannerWasm(): void {
  if (isInitialized) {
    console.log('⏭️  [QR Scanner Init] Already initialized, skipping');
    return;
  }

  console.log('🔧 [QR Scanner Init] Initializing WASM with local path');

  // BarcodeDetectorが初めて使用される前に設定を適用
  prepareZXingModule({
    overrides: {
      locateFile: (path: string, prefix: string) => {
        console.log(
          '🔍 [QR Scanner Init] Locating WASM file:',
          path,
          'prefix:',
          prefix,
        );

        // WASMファイルの場合、ローカルのpublicディレクトリから読み込む
        if (path.endsWith('.wasm')) {
          const localPath = `/wasm/${path}`;
          console.log('✅ [QR Scanner Init] Using local WASM path:', localPath);
          return localPath;
        }

        // その他のファイルはデフォルトのパスを使用
        return prefix + path;
      },
    },
  });

  isInitialized = true;
  console.log('✅ [QR Scanner Init] WASM configuration completed');
}
